import { RefObject, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { CONSOLE_HEADER_RESIZE_EVENT } from '../constants';
import { throttle } from './throttle';

/*
This hook is needed because FIT element Popover's position only gets updated when resize or scroll
When DOM element changes / the height of the page changes, we need reposition popover as well
So here added a ResizeObserver to fire a resize event to force popover reposition after DOM changes
*/
export const usePopoverResizeObserver = ({
  popoverResizeRef,
}: {
  popoverResizeRef: RefObject<HTMLElement>;
}): void => {
  useEffect(() => {
    if (!popoverResizeRef.current) {
      throw new Error(
        'usePopoverResizeObserver failure - desktop page header not rendered.',
      );
    }
    const observer = new ResizeObserver(
      throttle(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100),
    );
    observer.observe(popoverResizeRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);
};

export const useEventListener = ({
  eventName,
  callback,
}: {
  eventName: string;
  callback: (e: Event) => void;
}): void => {
  useEffect(() => {
    document.addEventListener(eventName, callback);
    return () => {
      document.removeEventListener(eventName, callback);
    };
  }, [eventName, callback]);
};

export const useHeaderResizeListener = ({
  callback,
}: {
  callback: (e: Event) => void;
}): void => {
  useEventListener({ eventName: CONSOLE_HEADER_RESIZE_EVENT, callback });
};
